import apiClient from './apiClient';

export interface Document {
  id: number;
  document_name?: string;
  file_name?: string;
  entity_name?: string;
  module_type?: string;
  status?: string;
  validation_status?: string;
  document_ref_number?: string;
  file_url?: string;
  is_deleted?: boolean;
  created_date?: string;
  updated_at?: string;
  validated_by?: number;
  validated_by_name?: string;
  validation_date?: string;
  validation_notes?: string;
  rejection_reason?: string;
  uploaded_by_name?: string;
}

export interface DocumentFilters {
  module_type?: string;
  status?: string;
  is_deleted?: boolean;
  search?: string;
}

const documentApi = {
  getAll: (filters?: DocumentFilters) => {
    let endpoint = '/archive/documents';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<Document[]>(endpoint);
  },

  getById: (id: number) => {
    return apiClient.get<Document>(`/archive/documents/${id}`);
  },

  create: (data: Partial<Document>) => {
    return apiClient.post<Document>('/archive/documents', data);
  },

  update: (id: number, data: Partial<Document>) => {
    return apiClient.put<Document>(`/archive/documents/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/archive/documents/${id}`);
  },
};

export default documentApi;
